import styles from "./style.module.scss";

export const Header = () => {
  return (
    <div className={styles.header}>
      <h5>Ant Design Charts</h5>
    </div>
  );
};
